module.exports = "data:image/svg+xml,module.exports = __webpack_public_path__ + 'fonts/bjd-logoefcddd8b97411758fba4ec32a4ac8801.svg';"